module.exports = __webpack_public_path__ + "static/media/S32_black.c4b81d75.png";